class SoldInvestment {
    sellPrice;
    averageAcquisitionPrice;
    revolvingFundAmount;
    totalFeesPaid;
    soldAt;
    capitalGain;
    property;
    bricks;
    constructor(data) {
        this.averageAcquisitionPrice = data.averageAcquisitionPrice;
        this.bricks = data.bricks;
        this.capitalGain = data.capitalGain;
        this.property = data.property;
        this.revolvingFundAmount = data.revolvingFundAmount;
        this.sellPrice = data.sellPrice;
        this.soldAt = new Date(data.soldAt);
        this.totalFeesPaid = data.totalFeesPaid;
    }
    getNumberOfBricks() {
        return this.bricks.length;
    }
}
export default SoldInvestment;
